import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[rut]',
  standalone: true
})
export class RutDirective {
  private elem = inject(ElementRef);
  @HostListener('focus')
  public onFocus() {
    this.elem.nativeElement.value = this.rutFormat(this.elem.nativeElement.value) || '';
  }
  // @HostListener('blur')
  // public onBlur() {
  //   this.elem.nativeElement.value = this.rutFormat(this.elem.nativeElement.value) || '';
  // }
  @HostListener('keyup')
  public onKeyUp() {
    this.elem.nativeElement.value = this.rutFormat(this.elem.nativeElement.value) || '';
  }
  public rutFormat(rut: string): string {
    if (!rut || rut == null) return '';
    const _rut: string = this.rutClean(rut);
    if (_rut.length <= 1) {
      return _rut;
    }
    let result: string = `${_rut.slice(-4, -1)}-${_rut.substring(_rut.length - 1)}`;
    for (let i: number = 4; i < _rut.length; i += 3) {
      result = `${_rut.slice(-3 - i, -i)}.${result}`;
    }
    return result;

  }
  public rutClean(rut: string) {
    return rut
      .replace(/[^0-9kK]+/g, '')
      .replace(/^0+/, '')
      .toUpperCase();
  }

}